import { Injectable } from '@angular/core';
import { from, Observable, Subject } from 'rxjs';

import { AzureClient } from './azure-client.service';
import { LocationDistance } from '../models';



@Injectable()
export class QuickLaunchService {

    private _nearestLocations: Observable<LocationDistance[]>;

    _nearestlocations$: Subject<Observable<LocationDistance[]>> = <Subject<Observable<LocationDistance[]>>>new Subject();
    get nearestLocations$() { return this._nearestlocations$.asObservable(); }
    constructor(private azure: AzureClient) { }

    public loadNearestLocations() {
        var count: number = 5;
        var range: number = 5;

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((pos: Position) => {
                if (pos && pos.coords) {
                    var queryString = `lat=${pos.coords.latitude}&lng=${pos.coords.longitude}&cnt=${count}&rng=${range}`;
                    var table = this.azure.client.getTable('location/nearest');
                    this._nearestlocations$.next(from(<Promise<LocationDistance[]>>table.read(queryString)));
                }
            });
        }
    }
}